import {
  Link as AriaLink,
  type LinkProps as AriaLinkProps,
} from "react-aria-components"

import { cx } from "@uui/utils/cx"

export interface LinkProps extends AriaLinkProps {
  variant?: "primary" | "secondary" | "tertiary" | "muted" | "nav"
}

export const Link = ({
  className,
  variant = "primary",
  ...props
}: LinkProps) => {
  return (
    <AriaLink
      {...props}
      className={cx(
        "cursor-pointer transition-colors duration-200 outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
        variant === "primary" && "text-brand-600 hover:text-brand-700",
        variant === "secondary" && "text-slate-600 hover:text-slate-900",
        variant === "tertiary" && "text-slate-500 hover:text-slate-700",
        variant === "muted" && "text-muted-foreground hover:text-foreground", // Adapted if needed
        variant === "nav" && "font-medium text-slate-500 hover:text-slate-900",
        typeof className === "string" ? className : "",
      )}
    />
  )
}
